"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 8: MROM (Absolute)
 * ------------------------------------------------------------------ */
// MROM (32 KB PRG switch)

function register(Mappers) {
  Mappers[8] = function (nes) {
    this.nes = nes;
  };

  Mappers[8].prototype = new Mappers[0]();

  Mappers[8].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
  };

  Mappers[8].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // A write anywhere in $8000-$FFFF latches the 32 KB bank number. Only five
    // bits reach the board, and everything the register does not select is left
    // alone, so a write is just a bank switch.
    this.prgBank = value & 0x1f;
    this.load32kRomBank(this.prgBank, 0x8000);
  };

  Mappers[8].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("MROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    // Bank 0 at power on, so the reset vector in the first 32 KB is reachable.
    this.load32kRomBank(0, 0x8000);
    // Mapper 8 has no CHR register and is normally built with CHR-RAM, but a dump
    // can still carry pattern ROM, and loadCHRROM leaves the RAM alone when the
    // header says there is none.
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };

  Mappers[8].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank = this.prgBank;
    return s;
  };

  Mappers[8].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank = s.prgBank;
  };
}

module.exports = { register: register };
